import React, { createContext, useContext, useMemo } from 'react';
import { useJsApiLoader } from '@react-google-maps/api';

import { V2_GOOGLE_MAPS_LIBRARIES, V2_GOOGLE_MAPS_LOADER_ID } from '../googleMapsLoader';

const defaultValue = {
  mapKey: '',
  isLoaded: false,
  loadError: undefined,
};

const V2GoogleMapsContext = createContext(defaultValue);

/** Loads Google Maps once for the whole v2 app (Loader is a browser singleton). */
export function V2GoogleMapsProvider({ children }) {
  const mapKey = (process.env.REACT_APP_MAP_KEY || '').trim();
  const { isLoaded, loadError } = useJsApiLoader({
    id: V2_GOOGLE_MAPS_LOADER_ID,
    googleMapsApiKey: mapKey,
    libraries: V2_GOOGLE_MAPS_LIBRARIES,
  });

  const value = useMemo(
    () => ({
      mapKey,
      isLoaded: Boolean(mapKey) && isLoaded,
      loadError,
    }),
    [mapKey, isLoaded, loadError]
  );

  return <V2GoogleMapsContext.Provider value={value}>{children}</V2GoogleMapsContext.Provider>;
}

export function useV2GoogleMaps() {
  return useContext(V2GoogleMapsContext);
}
